import {
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  UPDATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_ERROR,
  TOGGLE_SUBSCRIPTION_MODAL,
} from "./actionTypes";

export const getSubscriptions = (request) => {
  return {
    type: GET_SUBSCRIPTIONS,
    payload: { request },
  };
};

export const getSubscriptionsSuccess = (data) => {
  return {
    type: GET_SUBSCRIPTIONS_SUCCESS,
    payload: data,
  };
};

export const getSubscriptionsError = (message) => {
  return {
    type: GET_SUBSCRIPTIONS_ERROR,
    payload: message,
  };
};

export const getSubscription = (id) => {
  return {
    type: GET_SUBSCRIPTION,
    payload: { id },
  };
};

export const getSubscriptionSuccess = (data) => {
  return {
    type: GET_SUBSCRIPTION_SUCCESS,
    payload: data,
  };
};

export const getSubscriptionError = (message) => {
  return {
    type: GET_SUBSCRIPTION_ERROR,
    payload: message,
  };
};

export const updateSubscription = (request) => {
  return {
    type: UPDATE_SUBSCRIPTION,
    payload: { request },
  };
};

export const updateSubscriptionSuccess = () => {
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
  };
};

export const updateSubscriptionError = (error) => {
  return {
    type: UPDATE_SUBSCRIPTION_ERROR,
    payload: error,
  };
};

export const toggleSubscriptionModalAction = () => {
  return {
    type: TOGGLE_SUBSCRIPTION_MODAL,
  };
};
